import Divider from '@mui/material/Divider';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface DividerWithTextProps {
  color?: string;
  sx?: SxProps<Theme>;
  text: string;
}

export default function DividerWithText({ color, sx, text }: DividerWithTextProps) {
  return (
    <Divider
      sx={[
        (theme) => ({
          mt: 1.5,
          '&:before,&:after': {
            borderTopColor: color ?? theme.brandV2.colors.treadGray6,
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        sx={(theme) => ({
          color: color ?? theme.brandV2.colors.treadGray6,
          fontSize: '12px',
          fontWeight: 700,
          textTransform: 'uppercase',
        })}
      >
        {text}
      </Typography>
    </Divider>
  );
}
